<template>
    <BaseChip :size="size" :class="categoryClasses[color]"><slot /></BaseChip>
</template>

<script lang="ts">
import type { BaseChipSize } from "~vue/components/BaseChip.vue";
import { InsightCategoryColor } from "~vue/Labs/insightCategory";

interface InsightCategoryChipProps {
    color: InsightCategoryColor;
    size?: BaseChipSize;
}
</script>

<script setup lang="ts">
import BaseChip from "~vue/components/BaseChip.vue";

const { color, size = "2xs" } = defineProps<InsightCategoryChipProps>();

const categoryClasses: Record<InsightCategoryColor, string> = {
    [InsightCategoryColor.TEAL]: "category-teal",
    [InsightCategoryColor.PINK]: "category-pink",
    [InsightCategoryColor.ORANGE]: "category-orange",
    [InsightCategoryColor.GREEN]: "category-green",
};
</script>

<style scoped>
@layer components {
    .category-teal {
        --base-chip-bg: var(--color-lab-insight-category-teal-bg);
        --base-chip-text: var(--color-lab-insight-category-teal-text);
    }

    .category-pink {
        --base-chip-bg: var(--color-lab-insight-category-pink-bg);
        --base-chip-text: var(--color-lab-insight-category-pink-text);
    }

    .category-orange {
        --base-chip-bg: var(--color-lab-insight-category-orange-bg);
        --base-chip-text: var(--color-lab-insight-category-orange-text);
    }

    .category-green {
        --base-chip-bg: var(--color-lab-insight-category-green-bg);
        --base-chip-text: var(--color-lab-insight-category-green-text);
    }
}
</style>
